"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _home = require("@/api/home");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _bar = _interopRequireDefault(require("./bar"));
var _default2 = exports.default = {
  components: {
    bar: _bar.default
  },
  props: {
    chartData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      isShow: true,
      numberData: {},
      projectInfo: {},
      dayColdPrice: [],
      dayColdPriceDate: [],
      monthColdPrice: [],
      monthColdPriceDate: [],
      yearColdPrice: [],
      jd: 0,
      colorType: '',
      echartfc: '',
      // 图表颜色
      zoom: '',
      zoomrAtio: ''
    };
  },
  watch: {
    chartData: function chartData(val) {
      var res = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(val)));
      var day = Number(res.dayColdPrice || res.dayCop || 0);
      var month = Number(res.monthColdPrice || res.monthCop || 0);
      var year = Number(res.yearColdPrice || res.yearCop || 0);
      this.numberData = {
        day: day === 0 ? 0 : day.toFixed(2),
        month: month === 0 ? 0 : month.toFixed(2),
        year: year === 0 ? 0 : year.toFixed(2)
      };
    },
    isShow: function isShow(val) {
      if (val) {
        this.$store.dispatch("project/setProjectCold", 1);
        this.getCopData();
      } else {
        this.$store.dispatch("project/setProjectCold", 2);
        this.getColdPriceData();
      }
    },
    "$store.state.project.colorType": function $storeStateProjectColorType() {
      this.colorType = this.$store.state.project.colorType;
      if (this.colorType == 'theme_jyh') {
        this.echartfc = '#fff';
      } else if (this.colorType == 'theme_ytl') {
        this.echartfc = '#fff';
      } else {
        this.echartfc = '#fff';
      }
      this.getLineEcharts();
      this.getBarEcharts();
    }
  },
  created: function created() {
    if (JSON.parse(sessionStorage.getItem("projectInfo"))) {
      this.projectInfo = JSON.parse(sessionStorage.getItem("projectInfo"));
    }
    this.colorType = this.$store.state.project.colorType;
    if (this.colorType == 'theme_jyh') {
      this.echartfc = '#fff';
    } else if (this.colorType == 'theme_ytl') {
      this.echartfc = '#fff';
    } else {
      this.echartfc = '#fff';
    }
  },
  mounted: function mounted() {
    this.getCopData();
  },
  methods: {
    getColdPriceData: function getColdPriceData() {
      var _this = this;
      (0, _home.getColdPrice)({
        projectId: this.projectInfo.id,
        type: 2
      }).then(function (res) {
        _this.dayColdPrice = res[0].dayColdPrice.map(function (e) {
          return e.coldPriceValue;
        });
        _this.dayColdPriceDate = res[0].dayColdPrice.map(function (e) {
          // return dayjs(e.dataTime).format("MM-DD");
          return e.dataTime.substr(5, 5);
        });
        _this.monthColdPrice = res[1].monthColdPrice.map(function (e) {
          return e.coldPriceValue;
        });
        _this.monthColdPriceDate = res[1].monthColdPrice.map(function (e) {
          // return dayjs(e.dataTime).format("MM");
          return e.dataTime.substr(5, 2);
        });
        _this.yearColdPrice = res[2].yearColdPrice.map(function (e) {
          return e.coldPriceValue;
        });
        _this.yearColdPrice.push(_this.projectInfo.coldPriceTargetValue);
        if (_this.yearColdPrice.length > 1) {
          _this.jd = (_this.yearColdPrice[0] / _this.yearColdPrice[1] * 100).toFixed(2);
        }
        _this.getLineEcharts();
        _this.getBarEcharts();
        // this.getAcrossBarEcharts()
      });
    },
    getCopData: function getCopData() {
      var _this2 = this;
      (0, _home.getCop)({
        projectId: this.projectInfo.id,
        type: 1
      }).then(function (res) {
        //console.log("getCopData:", res);
        if (res.length == 0) {
          _this2.getLineEcharts();
          _this2.getBarEcharts();
          return;
        }
        _this2.dayColdPrice = res[0].dayCop.map(function (e) {
          return e.copValue;
        });
        _this2.dayColdPriceDate = res[0].dayCop.map(function (e) {
          // return dayjs(e.dataTime).format("MM-DD");
          return e.dataTime.substr(5, 5);
        });
        _this2.monthColdPrice = res[1].monthCop.map(function (e) {
          return e.copValue;
        });
        _this2.monthColdPriceDate = res[1].monthCop.map(function (e) {
          return (0, _dayjs.default)(e.dataTime).format("MM");
        });
        _this2.yearColdPrice = res[2].yearCop.map(function (e) {
          return e.copValue;
        });
        _this2.yearColdPrice.push(_this2.projectInfo.copTargetValue);
        if (_this2.yearColdPrice.length > 1) {
          _this2.jd = (_this2.yearColdPrice[0] / _this2.yearColdPrice[1] * 100).toFixed(2);
        }
        _this2.getLineEcharts();
        _this2.getBarEcharts();
        // this.getAcrossBarEcharts()
      });
    },
    Data: function Data() {
      var _this3 = this;
      (0, _home.getColdPrice)({
        projectId: this.projectInfo.id
      }).then(function (res) {
        _this3.dayColdPrice = res[0].dayColdPrice.map(function (e) {
          return e.coldPriceValue;
        });
        _this3.dayColdPriceDate = res[0].dayColdPrice.map(function (e) {
          return e.dataTime;
        });
        _this3.monthColdPrice = res[1].monthColdPrice.map(function (e) {
          return e.coldPriceValue;
        });
        _this3.monthColdPriceDate = res[1].monthColdPrice.map(function (e) {
          return e.dataTime;
        });
        _this3.yearColdPrice = res[2].yearColdPrice.map(function (e) {
          return e.coldPriceValue;
        });
        _this3.yearColdPrice.push(_this3.projectInfo.coldPriceTargetValue);
        if (_this3.yearColdPrice.length > 1) {
          _this3.jd = (_this3.yearColdPrice[0] / _this3.yearColdPrice[1] * 100).toFixed(2);
        }
      });
    },
    getLineEcharts: function getLineEcharts() {
      var _this4 = this;
      var lineEcharts = this.$echarts.init(document.getElementById("lineEcharts"));
      var option = {
        grid: {
          left: "10%",
          right: "15%",
          top: "27%",
          bottom: "30%" // 也可设置left和right设置距离来控制图表的大小
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            inside: false,
            textStyle: {
              fontSize: 10
            }
          },
          axisLine: {
            // y轴
            show: false,
            lineStyle: {
              color: this.echartfc //x轴轴线颜色
            }
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          splitLine: {
            // 网格线
            show: false
          },
          data: this.dayColdPriceDate
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,1)",
          extraCssText: "box-shadow:0 0 18px rgba(0,120,234,0.1);color:#000000",
          textStyle: {
            fontSize: 12,
            lineHeight: 30
          },
          padding: 15
        },
        yAxis: {
          type: "value",
          show: false,
          axisLine: {
            // y轴
            show: false
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          splitLine: {
            // 网格线
            show: false
          }
        },
        //
        series: [{
          data: this.dayColdPrice,
          type: "line",
          areaStyle: {},
          lineStyle: {
            color: "#FACF55",
            width: 1.4
          },
          label: {
            show: true,
            position: 'top',
            color: this.echartfc
          },
          itemStyle: {
            label: {
              show: true
            },
            color: "rgb(250 207 85 / 40%)"
          }
        }]
      };
      lineEcharts.setOption(option);
      this.$nextTick(function () {
        _this4.zoom = document.body.style.zoom;
        _this4.zoomrAtio = (1 / document.body.style.zoom).toFixed(2);
      });
    },
    getBarEcharts: function getBarEcharts() {
      var barEcharts = this.$echarts.init(document.getElementById("barEcharts"));
      var option = {
        grid: {
          left: "10%",
          right: "15%",
          top: "20%",
          bottom: "30%" // 也可设置left和right设置距离来控制图表的大小
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            inside: false,
            textStyle: {
              fontSize: '11'
            }
          },
          axisLine: {
            // y轴
            show: false,
            lineStyle: {
              color: this.echartfc,
              //x轴轴线颜色
              fontSize: '10'
            }
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          splitLine: {
            // 网格线
            show: false
          },
          data: this.monthColdPriceDate
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,1)",
          extraCssText: "box-shadow:0 0 18px rgba(0,120,234,0.1);color:#000000",
          textStyle: {
            fontSize: 12,
            lineHeight: 30
          },
          padding: 15
        },
        yAxis: {
          type: "value",
          show: false,
          axisLine: {
            // y轴
            show: false
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          splitLine: {
            // 网格线
            show: false
          }
        },
        series: [{
          name: "",
          type: "bar",
          barWidth: "14",
          data: this.monthColdPrice,
          label: {
            show: true,
            position: 'top',
            color: this.echartfc
          },
          itemStyle: {
            label: {
              show: true,
              position: "top"
            },
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: "#1665D8"
            }, {
              offset: 0.68,
              color: "#257dff"
            }, {
              offset: 1,
              color: "#257dff"
            }])
          }
        }]
      };
      barEcharts.setOption(option);
    },
    getAcrossBarEcharts: function getAcrossBarEcharts() {
      var acrossBarEcharts = this.$echarts.init(document.getElementById("acrossBarEcharts"));
      // var src = 'https://img30.360buyimg.com/img/s280x240_jfs/t1/50854/4/14718/7883/5db93ea0Ef47add96/ce6848c5602022e2.png!cc_280x240.webp'
      setInterval(function () {}, 500);
      // var url = 'data:image/png;base64,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'
      // const src = 'http://zuohaotu.com/Download/020116004468_0left.gif'
      var option = {
        grid: {
          left: "14%",
          right: "7%",
          top: "44%",
          bottom: "0%" // 也可设置left和right设置距离来控制图表的大小
        },
        xAxis: {
          type: "value",
          splitLine: {
            // 网格线
            show: false
          }
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,1)",
          extraCssText: "box-shadow:0 0 18px rgba(0,120,234,0.1);width:100px;height:40px;color:#000000",
          textStyle: {
            fontSize: 12,
            lineHeight: 30
          },
          padding: 15
        },
        yAxis: {
          type: "category",
          data: ["实际", "目标"],
          axisLine: {
            // y轴
            show: false
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          splitLine: {
            // 网格线
            show: false
          }
        },
        series: [{
          name: "",
          type: "bar",
          barWidth: "26%",
          data: this.yearColdPrice,
          itemStyle: {
            // 通常情况下：
            // barBorderRadius: 20,
            color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              offset: 0,
              color: "#d9e5fa"
            }, {
              offset: 0.5,
              color: "#a1c5f6"
            }, {
              offset: 1,
              color: "#4793ec"
            }])
          }
        }]
      };
      acrossBarEcharts.setOption(option);
    },
    presentStyle: function presentStyle() {
      if (this.yearColdPrice[0] > this.yearColdPrice[1]) {
        return 'left:80%';
      } else {
        var str = this.yearColdPrice[0] / this.yearColdPrice[1] * 80;
        return "left:".concat(str, "%");
      }
    }
  }
};